const RoleEnum = Object.freeze({
    USER: { value: 'user', text: 'User' },
    STAFF: { value: 'staff', text: 'Staff' },
    DOCTOR: { value: 'doctor', text: 'Doctor' },
    ADMIN: { value: 'admin', text: 'Admin' },
    ADMIN_STAFF: { value: 'admin_staff', text: 'Admin Staff' },
});

export default RoleEnum;
